import Model from 'src/storage/base';

export class AuthPopupModel extends Model {
  id = 'AuthPopupModel';
  persistent = false;

  defaultState = () => ({
    step: 0
  });

  apiConfig = {
    password: {
      url: 'auth/password',
      validation: {
        username: 'emailAddress',
        password: 'password'
      },
      cancellable: true
    },
    signup: {
      url: 'auth/signup',
      validation: {
        firstName: 'firstName',
        lastName: 'lastName',
        username: 'username',
        email: 'emailAddress',
        phoneNumber: 'phoneNumber',
        password: 'password',
        isDoctor: 'boolean'
      },
      cancellable: true
    },
    checkUsername: {
      url: 'auth/verifyFields',
      validation: {},
      cancellable: true
    },
    checkEmail: {
      url: 'auth/verifyFields',
      validation: {},
      cancellable: true
    },
    verifyFields: {
      url: 'auth/verifyFields',
      validation: {},
      cancellable: true
    }
  };

  _events = {
    location: 'initLocation'
  };

  initLocation = (data) => {
    this.setState({
      countryName: data.country
    });
  };

  resetState = () => {
    let countryName = model.state.countryName;
    this.reset();
    this.setStateSilent({ countryName });
  };

  loginPassword = (cb) => {
    let req = {
      username: this.state.username,
      password: this.state.password,
      role: this.state.role
    };
    this.api('password', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.foxsocket().connect();
        this.emit('auth', { ...data, byPopup: true });
      }
    });
  };
  signUp = (cb, inviteCode) => {
    let req = {
      avatar: this.input('avatar')?.file || '',
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      username: this.state.username,
      email: this.state.email,
      phoneNumber: this.state.phoneNumber,
      password: this.state.password,
      gender: this.state.gender,
      birthday: this.state.birthday,
      isDoctor: false
    };
    if (inviteCode) {
      req.inviteCode = inviteCode;
    }
    this.api('signup', req, (err, data, success) => {
      if (success) {
        cb(true, data);
        this.foxsocket().connect();
        this.emit('auth', { ...data, byPopup: true });
      } else {
        cb(false);
      }
    });
  };

  handleChangeAvatar = (data) => {
    this.handleChange('avatar', data);
  };

  handleChangeForUsername = (n, v) => {
    this.cancelApi('checkUsername');
    this.handleChange(n, n === 'username' ? v?.toLowerCase() : v);
    clearTimeout(this.usernameInputTimeout);

    if (v) {
      this.usernameInputTimeout = setTimeout(
        n !== 'username' ? this.suggestionUsernameByName : this.suggestionUsername,
        200
      );
    } else {
      delete this.usernameInputTimeout;
    }
  };

  suggestionUsername = () => {
    delete this.usernameInputTimeout;
    const { username } = this.state;
    if (username) {
      let error = this.validate('username', username, 'signup');
      if (error) {
        this.setInvalidApi('signup', { username: error });
      } else {
        const params = this.state.type === 'doctor' ? this.state.usernameParams : {};
        this.api('checkUsername', { ...params, username }, (err, data) => {
          if (data?.username === true) {
            this.setState({ usernameSuggestion: null });
          } else {
            this.setInvalidApi('signup', { username: data.username });
            if (this.state.type === 'doctor') {
              this.setState({
                usernameSuggestion: (data['username_suggestion'] || '')
                  .replace('dr.', '')
                  .replace(params.clinicUsername ? '.' + params.clinicUsername : '', '')
              });
            } else this.setState({ usernameSuggestion: data['username_suggestion'] });
          }
        });
      }
    }
  };

  suggestionUsernameByName = () => {
    delete this.usernameInputTimeout;
    const { firstName = '', lastName = '', name = '' } = this.state;
    const n = name ? name : firstName + lastName;
    const username = n.split(' ').join('').toLowerCase();

    if (
      (name || (firstName && lastName)) &&
      username &&
      !this.validate('username', username, 'signup')
    ) {
      const params = this.state.type === 'doctor' ? this.state.usernameParams : {};
      this.api('checkUsername', { ...params, username }, (err, data) => {
        if (data?.username !== true) {
          if (this.state.type === 'doctor') {
            this.setState({
              username: data['username_suggestion']
                .replace('dr.', '')
                .replace(params.clinicUsername ? '.' + params.clinicUsername : '', '')
            });
          } else this.setState({ username: data['username_suggestion'] });
        } else {
          this.setState({ username });
        }
      });
    }
  };

  handleChangeForEmail = (n, email) => {
    this.cancelApi('checkEmail');
    this.handleChange(n, email);
    clearTimeout(this.emailInputTimeout);
    if (!!this.state.email && !this.validate('email', this.state.email, 'signup')) {
      this.emailInputTimeout = setTimeout(() => {
        this.api('checkEmail', { email }, (err, data) => {
          if (typeof data?.email === 'string') {
            this.log('checkEmail error', email, data.email);
            this.setInvalidApi('signup', { email: data.email });
          } else {
            this.log('checkEmail ok', email, data.email);
          }
        });
      }, 200);
    } else {
      delete this.emailInputTimeout;
    }
  };

  verifyFields = async (type, formFields) => {
    const { avatar, ...fields } = formFields;
    void avatar;
    let ok = true;
    let invalid = {};

    for (const name in fields) {
      if (!fields[name]) {
        invalid[name] = 'Field is required';
        ok = false;
      }
    }

    if (fields['password'] && fields['password2'] && fields['password'] !== fields['password2']) {
      invalid.password2 = "Passwords don't match";
      ok = false;
    }

    if (!ok) {
      this.setInvalidApi('signup', invalid);
      return ok;
    }

    const promise = new Promise((resolve) => {
      const req = fields;
      req.isDoctor = type === 'doctor';
      req.isClinic = type === 'clinic';
      this.api('verifyFields', req, (err, res, success) => {
        if (success) {
          const {
            email,
            phoneNumber,
            password,
            username,
            firstName,
            lastName,
            name,
            birthday,
            gender
          } = res;
          if (typeof email === 'string') {
            ok = false;
            invalid.email = email;
          }
          if (typeof phoneNumber === 'string') {
            ok = false;
            invalid.phoneNumber = phoneNumber;
          }
          if (typeof password === 'string') {
            ok = false;
            invalid.password = password;
          }
          if (typeof username === 'string') {
            ok = false;
            invalid.username = username;
          }
          if (typeof firstName === 'string') {
            ok = false;
            invalid.firstName = firstName;
          }
          if (typeof lastName === 'string') {
            ok = false;
            invalid.lastName = lastName;
          }
          if (typeof name === 'string') {
            ok = false;
            invalid.name = name;
          }
          if (typeof birthday === 'string') {
            ok = false;
            invalid.birthday = birthday;
          }
          if (typeof gender === 'string') {
            ok = false;
            invalid.gender = gender;
          }
          this.setInvalidApi('signup', invalid);
          resolve(ok);
        }
      });
    });

    return promise;
  };
}

const model = new AuthPopupModel();
export default model;
